export default "__VITE_ASSET__sFhtZLuP__"